import { EnumMessage } from '../enumMessage'
export default {
  [EnumMessage.success]: 'Success',
  [EnumMessage.error]: 'Error'
}
